import apiClient from "@/services/axios";

/** @param {{ forEncaissement?: boolean }} [opts] — when true, caisses are filtered to OWNER + DEPENSE_ENCAISSEMENT (incoming funds). */
export const fetchDecaissementLookups = (opts = {}) => {
  const params = {};
  if (opts.forEncaissement) params.forEncaissement = true;
  return apiClient.get("/compV3/decaissement/lookups/bootstrap", { params });
};

/** Optional `payment` in payload creates immediate or scheduled settlement in the same request. */
export const createDecaissementDepense = (payload) =>
  apiClient.put("/compV3/decaissement/depenses", { data: payload });

/** Standalone payment after depense exists. Immediate → payment doc; scheduled → { paymentMode, schedules, depenseId }. */
export const createDecaissementPayment = (depenseId, payload) =>
  apiClient.post(`/compV3/decaissement/depenses/${depenseId}/payments`, {
    data: payload,
  });

export const listDecaissementDepenses = () =>
  apiClient.get("/compV3/decaissement/depenses");

/** Filtered invoice list with pagination (query params). */
export const fetchInvoiceList = (params) =>
  apiClient.get("/compV3/decaissement/depenses/invoices", { params });
